import React from 'react'
import {linkedAssets, riskAnalysisProofTypes} from '@constants'
import CertificateStatus from '@components/certificate-status'
import AuditStatus from '@components/audit-status'

const Option = ({
  value,
  active,
  isSelected,
  onSelect,
  index,
  onMouseEnter,
  onMouseLeave,
  isMultiple,
  children,
  isLoading,
  metadata,
}) => {
  const {isDisabled, isHeader, isCheckboxAlwaysVisible} = metadata || {}
  return (
    <div
      className={`dropdown-item is-clickable ${active ? 'tw:bg-gray' : ''} ${
        !isMultiple && isSelected ? 'tw:bg-gray' : ''
      }
            ${value.disabled ? 'tw:bg-gray-light' : ''}
            ${value.type === 'header' ? 'is-option-header' : ''}
            `}
      title={value.text || ''}
      onMouseDown={e => e.preventDefault()}
      onClick={e => {
        e.preventDefault()
        if (!isDisabled) {
          onSelect(value)
        }
      }}
      onMouseEnter={() => !isDisabled && !value.type && onMouseEnter(index)}
      onMouseLeave={() => !isDisabled && !value.type && onMouseLeave(index)}
    >
      <div>
        <div style={{whiteSpace: 'nowrap'}} className="tw:flex is-align-items-center">
          {isCheckboxAlwaysVisible && isMultiple && !isSelected && <i className="fa-regular fa-square" />}
          {isMultiple && isSelected && <i className="tw:text-black fa-solid fa-check-square" />}
          <div style={{flex: 1}}>
            {children}
            <div style={{float: 'right'}}>
              {(linkedAssets.mapping.CERTIFICATE.toUpperCase() === metadata?.type ||
                riskAnalysisProofTypes.enumMapping.CERTIFICATION === metadata?.type) && (
                <CertificateStatus
                  status={metadata.status}
                  expirationDate={metadata.expirationDate}
                  type={metadata.type}
                />
              )}
              {linkedAssets.mapping.AUDIT.toUpperCase() === metadata?.type && (
                <AuditStatus expirationDate={metadata.expirationDate} type={metadata.type} />
              )}
            </div>
          </div>
        </div>
        {isLoading && <i className="fa-solid fa-spinner fa-spin" />}
      </div>
      {isHeader && <hr className="tw:my-1" />}
    </div>
  )
}

export default React.memo(Option)
